// ============================================================================
// InputGroup.jsx — Corelia UI v1.2
// Groupe de champs Input avec alignement H/V, FormLayout, thème unifié
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import Input from "./Input";
import FormLayout from "./FormLayout";

const InputGroup = ({
  fields = [],              // [{ name, label, value, placeholder, error }]
  onChange,                 // (fieldName, newValue) => {}
  orientation = "vertical", // "horizontal" | "vertical"
  disabled = false,
  width = "100%",
  gap = theme.spacing.md,
  style = {},
  inputStyle = {},          // surcharge interne du <input>
  layout = {},              // { labelPosition, labelWidth, align }
}) => {
  const {
    labelPosition = "left",
    labelWidth = null,
    align = "center",
  } = layout;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        alignItems: orientation === "horizontal" ? "flex-start" : "stretch",
        gap,
        width,
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "default",
        marginBottom: theme.spacing.md,
        ...style,
      }}
    >
      {fields.map((field, index) => (
        <FormLayout
          key={field.name ?? index}
          label={field.label}
          labelPosition={labelPosition}
          labelWidth={labelWidth}
          align={align}
          width="100%"
          style={{
            marginBottom:
              orientation === "vertical" && index < fields.length - 1
                ? theme.spacing.sm
                : 0,
          }}
        >
          <Input
            value={field.value}
            placeholder={field.placeholder}
            error={field.error}
            disabled={disabled}
            onChange={(e) =>
              !disabled && onChange(field.name, e.target.value)
            }
            style={{ margin: 0 }}
            inputStyle={inputStyle}
          />
        </FormLayout>
      ))}
    </div>
  );
};

export default InputGroup;
